import { useCallback } from 'react';
import * as pas from 'js/hooks/auth/pas';
import { useGetErrorMessage } from 'js/hooks/server';

export const usePinVerification = ({ onSuccess, onClose, setError }) => {
    const getErrorMessage = useGetErrorMessage();

    return useCallback(async (values) => {
        setError();

        try {
            await pas.validatePin(values.pin);
            await onSuccess();

            onClose();
        } catch (error) {
            const errorMessage = getErrorMessage(error);

            setError(errorMessage);

            return errorMessage;
        }
    }, [onSuccess, onClose, setError, getErrorMessage]);
};
